const withIndexSuffix = (fieldName, index) => {
    if (!fieldName) return fieldName
    return fieldName.endsWith('[]')
        ? fieldName.replace(/\[\]$/, '_' + index + '[]')
        : fieldName + '_' + index
}

export default {
    meni() {
        let dodajTrMeniButton = $('.dodaj-tr-meni')

        dodajTrMeniButton.on('click', function (e) {
            e.preventDefault()
            let $this = $(this)
            let osnovniMeniBlock = $('.osnovni-meni-block')
            let osnovniMeniBlockClone = osnovniMeniBlock.clone()
            let dodatniMenijiWrapper = $('.dodatni-meniji-wrapper')

            // empty all inputs, textareas, selects in osnovniMeniBlockClone, and also clear checkboxes
            osnovniMeniBlockClone.find('input,textarea,select').each(function() {
                if ($(this).is(':checkbox') || $(this).is(':radio')) {
                    $(this).prop('checked', false)
                } else {
                    $(this).val('')
                }
            })

            // remove class osnovni-meni-block from osnovniMeniBlock
            osnovniMeniBlockClone.removeClass('osnovni-meni-block')
            osnovniMeniBlockClone.addClass('pt-10')

            // get data-meni-block from osnovniMeniBlock
            let meniBlockNumber = dodatniMenijiWrapper.attr('data-dodatni-meniji')
            meniBlockNumber = parseInt(meniBlockNumber) + 1


            if(meniBlockNumber > 3) {
                $this.prop('disabled', true).addClass('opacity-40 cursor-not-allowed')
                return
            } else {
                $this.prop('disabled', false).removeClass('opacity-40 cursor-not-allowed hover:bg-[#e1e1e1]')
            }

            osnovniMeniBlockClone.find('.meni-block__naslov').removeClass('hidden').text('Dodatni meni '+(parseInt(meniBlockNumber) - 1))

            // set data-meni-block to osnovniMeniBlockClone
            osnovniMeniBlockClone.attr('data-meni-block', meniBlockNumber)

            // set .dodatni-meniji-wrapper data-dodatni-meniji to meniBlockNumber
            dodatniMenijiWrapper.attr('data-dodatni-meniji', meniBlockNumber)


            // add '_'+meniBlockNumber to all inputs, textareas, selects name and id, and all label for attributes
            osnovniMeniBlockClone.find('input,textarea,select').each(function() {
                const currentName = $(this).attr('name')
                const currentId = $(this).attr('id')
                $(this).attr('name', withIndexSuffix(currentName, meniBlockNumber))
                if (currentId) {
                    $(this).attr('id', currentId + '_' + meniBlockNumber)
                }
            })
            osnovniMeniBlockClone.find('label[for]').each(function() {
                const currentFor = $(this).attr('for')
                if (currentFor) {
                    $(this).attr('for', currentFor + '_' + meniBlockNumber)
                }
            })

            // find "Ime osnovnega menija" and change it to "Ime dodatnega menija "+ meniBlockNumber
            osnovniMeniBlockClone.find('.ime-osnovnega-menija').text('Ime dodatnega menija ' + (parseInt(meniBlockNumber) - 1))

            // Prištejemo 1 k dodatnemu meni wrapperju
            dodatniMenijiWrapper.attr('data-dodatni-meniji', meniBlockNumber)

            // append osnovniMeniBlock to dodatniMenijiWrapper
            dodatniMenijiWrapper.append(osnovniMeniBlockClone)

            dodaj_remove_gumb_meniji(meniBlockNumber)
        })





        // Handle remove gumb for meniji
        function dodaj_remove_gumb_meniji(menijiCount) {
            let menijiButtonWrapper = $('.dodaj-meniji-button-wrapper')

            let gumbiOdstraniCount = menijiButtonWrapper.find('.odstrani-meniji-button').length

            if (menijiCount > 1 && gumbiOdstraniCount === 0) {
                $('<div><div class="odstrani-meniji-button button button-grayout hover:bg-yellow! hover:border-yellow! font-normal! px-2! py-1! text-[10px] mb-2 inline-block">- Odstrani meni</div></div>')
                    .prependTo(menijiButtonWrapper)
            } else if(menijiCount === 1 && gumbiOdstraniCount > 0) {
                menijiButtonWrapper.find('.odstrani-meniji-button').remove()
            }


            let dodajMeniButton = $('.dodaj-tr-meni')
            if(menijiCount < 3) {
                dodajMeniButton.prop('disabled', false).removeClass('opacity-40 cursor-not-allowed hover:bg-[#e1e1e1]')
            } else {
                dodajMeniButton.prop('disabled', true).addClass('opacity-40 cursor-not-allowed hover:bg-[#e1e1e1]')
            }
        }


        // Odstranjenvanje menijev
        $(document).on('click', '.odstrani-meniji-button', function () {
    
            let $this = $(this)
            let menijiWrapper = $('.dodatni-meniji-wrapper')

            // Find the last .meniji element that is *not* the original template (which has class 'meniji' only)
            let lastInput = menijiWrapper.find('.meni-block').last()
            lastInput.remove()

            // decrease data-meniji in menijiWrapper
            let menijiCount = menijiWrapper.attr('data-dodatni-meniji')
            menijiCount = parseInt(menijiCount) - 1

            menijiWrapper.attr('data-dodatni-meniji', menijiCount)

            dodaj_remove_gumb_meniji(menijiCount)
        })



    },









    lokalniDobavitelji() {
        let dodajDobaviteljButton = $('.dodaj-dobavitelj-button')

        dodajDobaviteljButton.on('click', function (e) {
            e.preventDefault()
            let $this = $(this)
            let lokalniDobaviteljiWrapper = $('.lokalni-dobavitelji-wrapper')
            let dobaviteljiCount = lokalniDobaviteljiWrapper.attr('data-dobavitelji')

            dobaviteljiCount = parseInt(dobaviteljiCount) + 1
            console.log(dobaviteljiCount)

            if(dobaviteljiCount > 7) {
                $this.prop('disabled', true).addClass('opacity-40 cursor-not-allowed! hover:bg-[#e1e1e1]!')
                return
            } else {
                $this.prop('disabled', false).removeClass('opacity-40 cursor-not-allowed! hover:bg-[#e1e1e1]!')
            }

            // set data-dobavitelji to dobaviteljiCount
            lokalniDobaviteljiWrapper.data('dobavitelji', dobaviteljiCount)

            let lokalniDobaviteljiBlock = $('.dobavitelj').clone()
            lokalniDobaviteljiBlock.removeClass('dobavitelj')
            lokalniDobaviteljiBlock.addClass('dobavitelj_' + dobaviteljiCount)
            
            lokalniDobaviteljiBlock.find('input,textarea,select').val('')
            // Only the first supplier name is required (data-dobavitelj="1").
            // Remove any required attrs from the cloned block.
            lokalniDobaviteljiBlock.find('[required]').removeAttr('required')

            // set data-dobavitelj to dobaviteljiCount
            lokalniDobaviteljiBlock.attr('data-dobavitelj', dobaviteljiCount)

            lokalniDobaviteljiBlock.find('h5').text('Dobavitelj '+ dobaviteljiCount)
        
            // add '_'+meniBlockNumber to all inputs, textareas, selects name and id, and all label for attributes
            lokalniDobaviteljiBlock.find('input,textarea,select').each(function() {
                $(this).attr('name', $(this).attr('name') + '_' + dobaviteljiCount)
                $(this).attr('id', $(this).attr('id') + '_' + dobaviteljiCount)
            })

            // append lokalniDobaviteljiBlock to lokalniDobaviteljiWrapper
            lokalniDobaviteljiWrapper.append(lokalniDobaviteljiBlock)

            lokalniDobaviteljiWrapper.attr('data-dobavitelji', dobaviteljiCount)

            dodaj_remove_gumb_lokalniDobavitelj(dobaviteljiCount)
        })



        // Handle remove gumb for lokalni dobavitelji
        function dodaj_remove_gumb_lokalniDobavitelj(dobaviteljiCount) {
            let dobaviteljButtonWrapper = $('.dodaj-dobavitelj-button-wrapper')

            let gumbiOdstraniCount = dobaviteljButtonWrapper.find('.odstrani-dobavitelj-button').length

            if (dobaviteljiCount > 1 && gumbiOdstraniCount === 0) {
                $('<div><div class="odstrani-dobavitelj-button button button-grayout hover:bg-yellow! hover:border-yellow! font-normal! px-2! py-1! text-[10px] mb-2 inline-block">- Odstrani dobavitelja</div></div>')
                    .prependTo(dobaviteljButtonWrapper)
            } else if(dobaviteljiCount === 1 && gumbiOdstraniCount > 0) {
                dobaviteljButtonWrapper.find('.odstrani-dobavitelj-button').remove()
            }
        }


        // Odstranjenvanje Dobaviteljev
        $(document).on('click', '.odstrani-dobavitelj-button', function () {
            let dobaviteljiWrapper = $('.lokalni-dobavitelji-wrapper')

            // Find the last .dobavitelj element that is *not* the original template (which has class 'dobavitelj' only)
            let lastInput = dobaviteljiWrapper.find('.dobavitelj_box').last()
            lastInput.remove()

            // decrease data-dobavitelji in dobaviteljiWrapper
            let dobaviteljiCount = dobaviteljiWrapper.attr('data-dobavitelji')
            dobaviteljiCount = parseInt(dobaviteljiCount) - 1


            let dodajDobaviteljButton = $('.dodaj-dobavitelj-button')
          
            if(dobaviteljiCount > 7) {
                dodajDobaviteljButton.prop('disabled', true).addClass('opacity-40 cursor-not-allowed! hover:bg-[#e1e1e1]!')
                return
            } else {
                dodajDobaviteljButton.prop('disabled', false).removeClass('opacity-40 cursor-not-allowed! hover:bg-[#e1e1e1]!')
            }

            dobaviteljiWrapper.attr('data-dobavitelji', dobaviteljiCount)

            dodaj_remove_gumb_lokalniDobavitelj(dobaviteljiCount)
        })


    },









    dodatniHodDoplacilo() {

        let dodajDodatniHodDoplaciloButton = $('.dodaj-dodatni-hod-doplacilo')

        dodajDodatniHodDoplaciloButton.on('click', function (e) {
            e.preventDefault()
            let dodatniHodDoplaciloWrapper = $('.dodatni-hodi-doplacilo-wrapper')
            let dodatniHodDoplaciloButtonWrapper = $('.dodatni-hodi-doplacilo-button')

            let $this = $(this)

            $this.toggleClass('odprto')

            // toggle html content in dodatniHodDoplaciloButtonWrapper
            let dodajText = '+ Dodaj dodatni <strong>hod z doplačilom</strong>';
            let odstraniText = '- Odstrani dodatni <strong>hod z doplačilom</strong>';


            if ($this.hasClass('odprto')) {
                $this.html(odstraniText)

                // show dodatniHodDoplaciloWrapper
                dodatniHodDoplaciloWrapper.removeClass('hidden')
                dodatniHodDoplaciloButtonWrapper.removeClass('hidden')
            } else {
                $this.html(dodajText)

                // set all textarea, input, checkbox to empty
                dodatniHodDoplaciloWrapper.find('input,textarea,select').each(function () {
                    if ($(this).is(':checkbox') || $(this).is(':radio')) {
                        $(this).prop('checked', false)
                    } else {
                        $(this).val('')
                    }
                })

                // hide dodatniHodDoplaciloWrapper
                dodatniHodDoplaciloWrapper.addClass('hidden')
                dodatniHodDoplaciloButtonWrapper.addClass('hidden')
            }
        })


        let dodajDodatniHodButton = $('.dodatni-hodi-doplacilo-button__dodaj')

        dodajDodatniHodButton.on('click', function (e) {
            e.preventDefault()
            
            let $this = $(this)
            let dodatniHodDoplaciloWrapper = $('.dodatni-hodi-doplacilo-wrapper')
            let dodatniHodDoplaciloCount = dodatniHodDoplaciloWrapper.attr('data-dodatni-hod')
            let hodFormaClone = dodatniHodDoplaciloWrapper.find('.dodatni-hod').clone()

            // empty all inputs, textareas, selects in osnovniMeniBlockClone, and also clear checkboxes
            hodFormaClone.find('input,textarea,select').each(function() {
                if ($(this).is(':checkbox') || $(this).is(':radio')) {
                    $(this).prop('checked', false)
                } else {
                    $(this).val('')
                }
            })
            
            dodatniHodDoplaciloCount = parseInt(dodatniHodDoplaciloCount) + 1

            if(dodatniHodDoplaciloCount > 5) {
                $this.prop('disabled', true).addClass('opacity-40 cursor-not-allowed hover:bg-[#e1e1e1]')
                return
            } else {
                $this.prop('disabled', false).removeClass('opacity-40 cursor-not-allowed hover:bg-[#e1e1e1]')
            }

            // remove class dodatni-hod from hodForma
            hodFormaClone.removeClass('dodatni-hod')
            hodFormaClone.addClass('dodatni-hod_'+dodatniHodDoplaciloCount)
            hodFormaClone.addClass('pt-14')

            dodatniHodDoplaciloWrapper.attr('data-dodatni-hod', dodatniHodDoplaciloCount)
            hodFormaClone.find('h5').text(dodatniHodDoplaciloCount + '. Dodatni hod:')

            // add '_'+meniBlockNumber to all inputs, textareas, selects name and id, and all label for attributes
            hodFormaClone.find('input,textarea,select').each(function() {
                const currentName = $(this).attr('name')
                const currentId = $(this).attr('id')
                $(this).attr('name', withIndexSuffix(currentName, dodatniHodDoplaciloCount))
                if (currentId) {
                    $(this).attr('id', currentId + '_' + dodatniHodDoplaciloCount)
                }
            })
            hodFormaClone.find('label[for]').each(function() {
                const currentFor = $(this).attr('for')
                if (currentFor) {
                    $(this).attr('for', currentFor + '_' + dodatniHodDoplaciloCount)
                }
            })

            // append hodForma to dodatniHodDoplaciloWrapper
            dodatniHodDoplaciloWrapper.append(hodFormaClone)

            dodaj_remove_gumb_dodatnihod(dodatniHodDoplaciloCount)
        })




        // Odstranjenvanje Dodatnih hodov
        $(document).on('click', '.odstrani-dodatnihod-button', function () {
                let dodatnihodWrapper = $('.dodatni-hodi-doplacilo-wrapper')

            // Find the last .dodatnihod element that is *not* the original template (which has class 'dodatnihod' only)
            let lastInput = dodatnihodWrapper.find('.dodatnihod_box').last()
            lastInput.remove()

            // decrease data-dodatnihod in dodatnihodWrapper
            let dodatnihodCount = dodatnihodWrapper.attr('data-dodatni-hod')
            dodatnihodCount = parseInt(dodatnihodCount) - 1

            dodatnihodWrapper.attr('data-dodatni-hod', dodatnihodCount)

            dodaj_remove_gumb_dodatnihod(dodatnihodCount)
        })




        // Handle remove gumb for lokalni dodatnihod
        function dodaj_remove_gumb_dodatnihod(dodatnihodCount) {
            let dodatnihodButtonWrapper = $('.dodatni-hodi-doplacilo-button')

            let gumbiOdstraniCount = dodatnihodButtonWrapper.find('.odstrani-dodatnihod-button').length

            if (dodatnihodCount > 1 && gumbiOdstraniCount === 0) {
                $('<div><div class="odstrani-dodatnihod-button button button-grayout hover:bg-yellow! hover:border-yellow! font-normal! px-2! py-1! text-[10px] mb-2 inline-block">- Odstrani dodatni hod</div></div>')
                    .prependTo(dodatnihodButtonWrapper)
            } else if(dodatnihodCount === 1 && gumbiOdstraniCount > 0) {
                dodatnihodButtonWrapper.find('.odstrani-dodatnihod-button').remove()
            }
            


            let dodajHodButton = $('.dodatni-hodi-doplacilo-button__dodaj')
            if(dodatnihodCount < 5) {
                dodajHodButton.prop('disabled', false).removeClass('opacity-40 cursor-not-allowed hover:bg-[#e1e1e1]')
            } else {
                dodajHodButton.prop('disabled', true).addClass('opacity-40 cursor-not-allowed hover:bg-[#e1e1e1]')
            }
        }


    },


    vinarObveznaCena() {

        // set required attribute to #vinska_spremljava_cena if at least one of the fields in .vinska_spremljava__polja is filled.
        function vinskaSpremljavaCenaCheck() {
            let vinskaSpremljavaCena = $('#vinska_spremljava_cena')
            let vinskaSpremljavaPolja = $('.vinska_spremljava__polja input')

            // If at least one field is filled, require the price; otherwise, not required
            let anyFilled = false
            vinskaSpremljavaPolja.each(function() {
                if ($(this).val().trim() !== '') {
                    anyFilled = true
                    return false // break loop
                }
            })

            vinskaSpremljavaCena.prop('required', anyFilled)

            if(anyFilled) {
                $('.vinska_spremljava_cena_label').addClass('required').each(function() {
                    if ($(this).find('span.required-asterisk').length === 0) {
                        $(this).append('<span class="required-asterisk">*</span>')
                    }
                })
            } else {
                $('.vinska_spremljava_cena_label').removeClass('required').find('span.required-asterisk').remove()
            }
        }

        // set required attribute to #dodatna_vinska_spremljava_cena if at least one field in .dodatna_vinska_spremljava__polja is filled.
        function dodatnaVinskaSpremljavaCenaCheck() {
            let vinskaSpremljavaCena = $('#dodatna_vinska_spremljava_cena')
            let vinskaSpremljavaPolja = $('.dodatna_vinska_spremljava__polja input')
            if (vinskaSpremljavaCena.length === 0 || vinskaSpremljavaPolja.length === 0) return

            let anyFilled = false
            vinskaSpremljavaPolja.each(function() {
                if ($(this).val().trim() !== '') {
                    anyFilled = true
                    return false
                }
            })

            vinskaSpremljavaCena.prop('required', anyFilled)

            if(anyFilled) {
                $('.dodatna_vinska_spremljava_cena_label').addClass('required').each(function() {
                    if ($(this).find('span.required-asterisk').length === 0) {
                        $(this).append('<span class="required-asterisk">*</span>')
                    }
                })
            } else {
                $('.dodatna_vinska_spremljava_cena_label').removeClass('required').find('span.required-asterisk').remove()
            }
        }

        // Run on input
        $(document).on('input', '.vinska_spremljava__polja input', vinskaSpremljavaCenaCheck)
        $(document).on('input', '.dodatna_vinska_spremljava__polja input', dodatnaVinskaSpremljavaCenaCheck)
        vinskaSpremljavaCenaCheck()
        dodatnaVinskaSpremljavaCenaCheck()


    },

    vinskaSpremljava() {
        const $wrapper = $('.vinska-vina-wrapper')
        const $addBtn = $('.dodaj-vino-button')
        const $btnWrapper = $('.dodaj-vino-button-wrapper')

        if ($wrapper.length === 0 || $addBtn.length === 0) return

        function updateLetnikRequiredForBox($box) {
            if (!$box || $box.length === 0) return

            const $ime = $box.find('input[name^="vinska_spremljava_"][name$="_ime"]').first()
            const $letnik = $box.find('input[name^="vinska_spremljava_"][name$="_letnik"]').first()
            if ($ime.length === 0 || $letnik.length === 0) return

            const required = ($ime.val() || '').toString().trim() !== ''
            $letnik.prop('required', required)

            // Show/hide "*" on Letnik label when it becomes required
            const $letnikLabel = $letnik.closest('.mb-4').find('.mb-1').first()
            if ($letnikLabel.length) {
                if (required) {
                    if ($letnikLabel.find('span.required-asterisk').length === 0) {
                        $letnikLabel.append('<span class="required-asterisk">*</span>')
                    }
                } else {
                    $letnikLabel.find('span.required-asterisk').remove()
                }
            }
        }

        function updateLetnikRequiredAll() {
            $wrapper.find('.vino_box').each(function() {
                updateLetnikRequiredForBox($(this))
            })
        }

        function getCount() {
            const c = parseInt($wrapper.attr('data-vina') || '1', 10)
            return isNaN(c) ? 1 : c
        }

        function setCount(c) {
            $wrapper.attr('data-vina', c)
        }

        function updateButtons(count) {
            const hasRemove = $btnWrapper.find('.odstrani-vino-button').length > 0
            if (count > 1 && !hasRemove) {
                $('<div><div class="odstrani-vino-button button button-grayout hover:bg-yellow! hover:border-yellow! font-normal! px-2! py-1! text-[10px] mb-2 inline-block">- Odstrani vino</div></div>')
                    .prependTo($btnWrapper)
            } else if (count === 1 && hasRemove) {
                $btnWrapper.find('.odstrani-vino-button').closest('div').remove()
            }

            if (count >= 4) {
                $addBtn.addClass('opacity-40 cursor-not-allowed! hover:bg-[#e1e1e1]!')
            } else {
                $addBtn.removeClass('opacity-40 cursor-not-allowed! hover:bg-[#e1e1e1]!')
            }
        }

        // Init
        updateButtons(getCount())
        updateLetnikRequiredAll()

        $addBtn.on('click', function (e) {
            e.preventDefault()

            let count = getCount()
            count = count + 1
            if (count > 4) {
                updateButtons(4)
                return
            }

            const $tpl = $wrapper.find('.vino').first()
            if ($tpl.length === 0) return

            const $clone = $tpl.clone()
            $clone.removeClass('vino').addClass('vino_' + count)
            $clone.attr('data-vino', count)
            $clone.find('h5').text('Vino ' + count)

            $clone.find('input,textarea,select').each(function() {
                const $el = $(this)
                $el.val('')

                const oldName = $el.attr('name') || ''
                const oldId = $el.attr('id') || ''
                const newPrefix = 'vinska_spremljava_' + count + '_'
                $el.attr('name', oldName.replace(/^vinska_spremljava_1_/, newPrefix))
                $el.attr('id', oldId.replace(/^vinska_spremljava_1_/, newPrefix))
            })

            $wrapper.append($clone)
            setCount(count)
            updateButtons(count)
            updateLetnikRequiredForBox($clone)

            // Re-evaluate price required rule
            $wrapper.find('input').first().trigger('input')
        })

        // If "Ime Vina" is filled, "Letnik" becomes required (per vino).
        $(document).on('input change', 'input[name^="vinska_spremljava_"][name$="_ime"]', function() {
            const $box = $(this).closest('.vino_box')
            updateLetnikRequiredForBox($box)
        })

        $(document).on('click', '.odstrani-vino-button', function (e) {
            e.preventDefault()

            let count = getCount()
            if (count <= 1) return

            $wrapper.find('.vino_box').last().remove()
            count = count - 1
            setCount(count)
            updateButtons(count)
            updateLetnikRequiredAll()

            // Re-evaluate price required rule
            $wrapper.find('input').first().trigger('input')
        })
    },


    dodatnaVinskaSpremljava() {
        const $section = $('.dodatna_vinska_spremljava')
        const $groupsWrapper = $section.find('.dodatne-vinske-spremljave-wrapper')
        const $templateItem = $section.find('.dodatna-vinska-item-template .dodatna-vinska-item').first()
        const $addGroupBtn = $section.find('.dodaj-dodatna-vinska-spremljava')
        const $removeGroupWrapper = $section.find('.dodaj-dodatna-vinska-spremljava-remove-wrapper')

        if ($section.length === 0 || $groupsWrapper.length === 0 || $templateItem.length === 0 || $addGroupBtn.length === 0) return

        // Največ dodatnih vinskih spremljav (enaka omejitev v dashboard-tr-meni.php in prijava-tr-shrani-meni.php).
        const MAX_GROUPS = parseInt($groupsWrapper.attr('data-max-dodatne-vinske-spremljave') || '3', 10) || 3

        function updateAddGroupButton(count) {
            $addGroupBtn.toggleClass('hidden', count >= MAX_GROUPS)
        }

        function setGroupCount(c) {
            $groupsWrapper.attr('data-dodatne-vinske-spremljave', c)
            updateAddGroupButton(c)
            if (c > 0) {
                $groupsWrapper.removeClass('hidden')
                $removeGroupWrapper.removeClass('hidden')
            } else {
                $groupsWrapper.addClass('hidden')
                $removeGroupWrapper.addClass('hidden')
            }
        }

        function updateRemoveGroupButton(count) {
            const hasRemove = $removeGroupWrapper.find('.odstrani-dodatna-vinska-spremljava-button').length > 0
            if (count > 0 && !hasRemove) {
                $('<div><div class="odstrani-dodatna-vinska-spremljava-button button button-grayout hover:bg-yellow! hover:border-yellow! font-normal! px-2! py-1! text-[10px] mb-2 inline-block">- Odstrani dodatno vinsko spremljavo</div></div>')
                    .prependTo($removeGroupWrapper)
            } else if (count === 0 && hasRemove) {
                $removeGroupWrapper.find('.odstrani-dodatna-vinska-spremljava-button').closest('div').remove()
            }
        }

        function updateLetnikRequiredForBox($box) {
            if (!$box || $box.length === 0) return
            const $ime = $box.find('input[data-field="ime"]').first()
            const $letnik = $box.find('input[data-field="letnik"]').first()
            if ($ime.length === 0 || $letnik.length === 0) return

            const required = ($ime.val() || '').toString().trim() !== ''
            $letnik.prop('required', required)

            const $letnikLabel = $letnik.closest('.mb-4').find('.mb-1').first()
            if ($letnikLabel.length) {
                if (required) {
                    if ($letnikLabel.find('span.required-asterisk').length === 0) {
                        $letnikLabel.append('<span class="required-asterisk">*</span>')
                    }
                } else {
                    $letnikLabel.find('span.required-asterisk').remove()
                }
            }
        }

        function updatePriceRequiredForGroup($group) {
            const $price = $group.find('input[data-field="cena"]').first()
            if ($price.length === 0) return

            let anyFilled = false
            $group.find('.dodatna-vinska-vina-wrapper input[data-field]').each(function() {
                if (String($(this).val() || '').trim() !== '') {
                    anyFilled = true
                    return false
                }
            })

            $price.prop('required', anyFilled)
            const $label = $group.find('.dodatna_vinska_spremljava_cena_label').first()
            if ($label.length) {
                if (anyFilled) {
                    if ($label.find('span.required-asterisk').length === 0) {
                        $label.append('<span class="required-asterisk">*</span>')
                    }
                } else {
                    $label.find('span.required-asterisk').remove()
                }
            }
        }

        function updateWineButtonsForGroup($group) {
            const $wineWrapper = $group.find('.dodatna-vinska-vina-wrapper').first()
            const $btnWrapper = $group.find('.dodaj-dodatno-vino-button-wrapper').first()
            const $addWineBtn = $btnWrapper.find('.dodaj-dodatno-vino-button').first()
            const wineCount = $wineWrapper.find('.vino_box').length
            $wineWrapper.attr('data-vina', wineCount)

            const hasRemove = $btnWrapper.find('.odstrani-dodatno-vino-button').length > 0
            if (wineCount > 1 && !hasRemove) {
                $('<div><div class="odstrani-dodatno-vino-button button button-grayout hover:bg-yellow! hover:border-yellow! font-normal! px-2! py-1! text-[10px] mb-2 inline-block">- Odstrani vino</div></div>')
                    .prependTo($btnWrapper)
            } else if (wineCount === 1 && hasRemove) {
                $btnWrapper.find('.odstrani-dodatno-vino-button').closest('div').remove()
            }

            if (wineCount >= 4) {
                $addWineBtn.addClass('opacity-40 cursor-not-allowed! hover:bg-[#e1e1e1]!')
            } else {
                $addWineBtn.removeClass('opacity-40 cursor-not-allowed! hover:bg-[#e1e1e1]!')
            }
        }

        function renumberGroup($group, groupIdx) {
            $group.attr('data-dodatna-vinska-item', groupIdx)
            $group.find('.dodatna-vinska-title').first().text('Dodatna vinska spremljava ' + groupIdx)

            const $price = $group.find('input[data-field="cena"]').first()
            if ($price.length) {
                const priceKey = 'dodatna_vinska_spremljava_' + groupIdx + '_cena'
                $price.attr('name', priceKey).attr('id', priceKey)
            }

            const $wineWrapper = $group.find('.dodatna-vinska-vina-wrapper').first()
            $wineWrapper.find('.vino_box').each(function(wineIdxZero) {
                const wineIdx = wineIdxZero + 1
                const $box = $(this)
                $box.attr('data-vino', wineIdx)
                $box.find('.dodatno-vino-title').first().text('Vino ' + wineIdx)

                $box.find('input[data-field]').each(function() {
                    const $input = $(this)
                    const field = String($input.attr('data-field') || '').trim()
                    if (!field || field === 'cena') return
                    const key = 'dodatna_vinska_spremljava_' + groupIdx + '_' + wineIdx + '_' + field
                    $input.attr('name', key).attr('id', key)
                })

                updateLetnikRequiredForBox($box)
            })

            updateWineButtonsForGroup($group)
            updatePriceRequiredForGroup($group)
        }

        function renumberAllGroups() {
            $groupsWrapper.find('.dodatna-vinska-item').each(function(groupIdxZero) {
                renumberGroup($(this), groupIdxZero + 1)
            })
        }

        const initialCount = $groupsWrapper.find('.dodatna-vinska-item').length
        setGroupCount(initialCount)
        updateRemoveGroupButton(initialCount)
        renumberAllGroups()

        $addGroupBtn.on('click', function (e) {
            e.preventDefault()
            if ($groupsWrapper.find('.dodatna-vinska-item').length >= MAX_GROUPS) return
            const $clone = $templateItem.clone()
            $clone.find('input,textarea,select').val('').prop('required', false)
            $clone.find('.required-asterisk').remove()

            $groupsWrapper.append($clone)
            const count = $groupsWrapper.find('.dodatna-vinska-item').length
            setGroupCount(count)
            updateRemoveGroupButton(count)
            renumberAllGroups()
        })

        $(document).on('click', '.odstrani-dodatna-vinska-spremljava-button', function (e) {
            e.preventDefault()
            const count = $groupsWrapper.find('.dodatna-vinska-item').length
            if (count <= 0) return

            $groupsWrapper.find('.dodatna-vinska-item').last().remove()
            const nextCount = $groupsWrapper.find('.dodatna-vinska-item').length
            setGroupCount(nextCount)
            updateRemoveGroupButton(nextCount)
            renumberAllGroups()
        })

        $(document).on('click', '.dodaj-dodatno-vino-button', function (e) {
            e.preventDefault()
            const $group = $(this).closest('.dodatna-vinska-item')
            if ($group.length === 0) return

            const $wineWrapper = $group.find('.dodatna-vinska-vina-wrapper').first()
            const wineCount = $wineWrapper.find('.vino_box').length
            if (wineCount >= 4) {
                updateWineButtonsForGroup($group)
                return
            }

            const $wineTpl = $wineWrapper.find('.vino_box').first()
            if ($wineTpl.length === 0) return

            const $clone = $wineTpl.clone()
            $clone.find('input,textarea,select').val('').prop('required', false)
            $clone.find('.required-asterisk').remove()
            $wineWrapper.append($clone)

            const groupIdx = parseInt($group.attr('data-dodatna-vinska-item') || '1', 10) || 1
            renumberGroup($group, groupIdx)
        })

        $(document).on('click', '.odstrani-dodatno-vino-button', function (e) {
            e.preventDefault()
            const $group = $(this).closest('.dodatna-vinska-item')
            if ($group.length === 0) return

            const $wineWrapper = $group.find('.dodatna-vinska-vina-wrapper').first()
            const wineCount = $wineWrapper.find('.vino_box').length
            if (wineCount <= 1) return

            $wineWrapper.find('.vino_box').last().remove()
            const groupIdx = parseInt($group.attr('data-dodatna-vinska-item') || '1', 10) || 1
            renumberGroup($group, groupIdx)
        })

        $(document).on('input change', '.dodatna-vinska-item .dodatna-vinska-vina-wrapper input[data-field="ime"]', function() {
            const $group = $(this).closest('.dodatna-vinska-item')
            const $box = $(this).closest('.vino_box')
            updateLetnikRequiredForBox($box)
            updatePriceRequiredForGroup($group)
        })

        $(document).on('input change', '.dodatna-vinska-item .dodatna-vinska-vina-wrapper input[data-field]', function() {
            updatePriceRequiredForGroup($(this).closest('.dodatna-vinska-item'))
        })
    },

    // Enable/disable ingredient flags based on master IKS checkbox
    iksEnableDisable() {
        const flags = ['govedina','perutnina','svinjina','sadje','mleko','zita']

        function toggleFor($iks) {
            const id = $iks.attr('id') || ''
            const m = id.match(/^(.+)_iks(_\d+)?$/)
            if (!m) return
            const prefix = m[1]
            const suffix = m[2] || ''
            const checked = $iks.is(':checked')

            flags.forEach(flag => {
                const $cb = $('#'+prefix+'_'+flag+suffix)
                if ($cb.length) {
                    $cb.prop('disabled', !checked)
                    if (!checked) $cb.prop('checked', false)

                    // Toggle label color on nearby .checkbox_label
                    const $labelText = $cb.closest('label').find('.checkbox_label')
                    if ($labelText.length) {
                        if ($cb.is(':disabled')) {
                            $labelText.addClass('text-[#A5A5A5]')
                        } else {
                            $labelText.removeClass('text-[#A5A5A5]')
                        }
                    }
                }
            })
        }

        // Initialize for existing blocks
        $('input.iks_main').each(function(){ toggleFor($(this)) })

        // Handle dynamically added blocks
        $(document).on('change', 'input.iks_main', function(){ toggleFor($(this)) })
    },


    dodatniChef() {
        const $wrapper = $('.dodatni-chefa-wrapper')
        const $btnAdd = $('.dodaj-chefa-button')
        const $btnRemove = $('.odstrani-chefa-button')
        const $ime = $('#ime_dodatnega_chefa')
        const $priimek = $('#priimek_dodatnega_chefa')

        if ($wrapper.length === 0 || $btnAdd.length === 0 || $btnRemove.length === 0) return

        function isEmpty(val) {
            return (val || '').toString().trim() === ''
        }

        function hasAnyValue() {
            return !isEmpty($ime.val()) || !isEmpty($priimek.val())
        }

        function applyState() {
            const showFields = hasAnyValue()

            if (showFields) {
                $wrapper.removeClass('hidden')
                $btnAdd.closest('div').addClass('hidden')
                $btnRemove.closest('div').removeClass('hidden')
            } else {
                $wrapper.addClass('hidden')
                $btnAdd.closest('div').removeClass('hidden')
                $btnRemove.closest('div').addClass('hidden')
            }
        }

        // Init
        applyState()

        // Add additional chef
        $btnAdd.on('click', function (e) {
            e.preventDefault()
            $wrapper.removeClass('hidden')
            $btnAdd.closest('div').addClass('hidden')
            $btnRemove.closest('div').removeClass('hidden')
            $ime.trigger('focus')
        })

        // Remove additional chef: clear values + hide section
        $btnRemove.on('click', function (e) {
            e.preventDefault()
            $ime.val('')
            $priimek.val('')
            applyState()
        })

        // If user manually clears both fields, hide section again
        $ime.on('input change blur', applyState)
        $priimek.on('input change blur', applyState)
    }
}
